// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20p7h","rootParamsCollapsed":"styles_rootParamsCollapsed__2r7mq","rootPreviewFull":"styles_rootPreviewFull__2pzI3","loader":"styles_loader__SLyVY"};